<template>
  <div id="totalBox">
    <table class="tableBox">
      <tr class="titleLine">
        <td rowspan="3" class="partner">车场合作经营项目</td>
        <td rowspan="3" class="partnerContent">创客合伙人合作内容</td>
        <td colspan="4" class="incomeTitle">创客合伙人获利</td>
      </tr>
      <tr class="titleLine">
        <td colspan="2" style="font-size: 16px;width: 354px;">一级</td>
        <td colspan="2" style="font-size: 16px;width: 354px;">二级</td>
      </tr>
      <tr class="titleLine">
        <td style="font-weight: 400;width: 176px;">
                  获利标准<br />
          <span style="font-size: 14px;">（元/车位/年）</span>
        </td>
        <td style="font-weight: 400;width: 176px;">
          1000车位获利
          <span style="font-size: 14px;">（元）</span>
        </td>
        <td style="font-weight: 400;width: 176px;">
                  获利标准<br />
          <span style="font-size: 14px;">（元/车位/年）</span>
        </td>
        <td style="font-weight: 400;width: 176px;">
          1000车位获利
           <span style="font-size: 14px;">（元）</span>
        </td>
      </tr>
      <tr>
        <td rowspan="2" class="partnerTitle">停车收益分成</td>
        <td class="contentStyle">仅提供车场关系人</td>
        <td class="contentStyle">12</td>
        <td class="incomeNumberStyle">12000</td>
        <td class="contentStyle">24</td>
        <td class="incomeNumberStyle">24000</td>
      </tr>
      <tr>
        <td class="contentStyle">主导完成合同签订</td>
        <td class="contentStyle">24</td>
        <td class="incomeNumberStyle">24000</td>
        <td class="contentStyle">48</td>
        <td class="incomeNumberStyle">48000</td>
      </tr>
      <tr>
        <td rowspan="2" class="partnerTitle">停车收益分成<br />+<span style="color: rgba(250, 62, 47, 1);">广告</span></td>
        <td class="contentStyle">仅提供车场关系人</td>
        <td class="contentStyle">13</td>
        <td class="incomeNumberStyle">13000</td>
        <td class="contentStyle">26</td>
        <td class="incomeNumberStyle">26000</td>
      </tr>
      <tr>
        <td class="contentStyle">主导完成合同签订</td>
        <td class="contentStyle">26</td>
        <td class="incomeNumberStyle">26000</td>
        <td class="contentStyle">52</td>
        <td class="incomeNumberStyle">52000</td>
      </tr>
      <tr>
        <td rowspan="2" class="partnerTitle">停车收益分成<br />+<span style="color: rgba(250, 62, 47, 1);">广告</span>+<span style="color: rgba(250, 62, 47, 1);">共享充电</span></td>
        <td class="contentStyle">仅提供车场关系人</td>
        <td class="contentStyle">14</td>
        <td class="incomeNumberStyle">14000</td>
        <td class="contentStyle">28</td>
        <td class="incomeNumberStyle">28000</td>
      </tr>
      <tr>
        <td class="contentStyle">主导完成合同签订</td>
        <td class="contentStyle">28</td>
        <td class="incomeNumberStyle">28000</td>
        <td class="contentStyle">56</td>
        <td class="incomeNumberStyle">56000</td>
      </tr>
      <tr>
        <td rowspan="2" class="partnerTitle">停车收益分成<br />+<span style="color: rgba(250, 62, 47, 1);">广告</span>+<span style="color: rgba(250, 62, 47, 1);">共享充电</span>+<span style="color: rgba(250, 62, 47, 1);">无人洗车</span></td>
        <td class="contentStyle">仅提供车场关系人</td>
        <td class="contentStyle">15</td>
        <td class="incomeNumberStyle">15000</td>
        <td class="contentStyle">30</td>
        <td class="incomeNumberStyle">30000</td>
      </tr>
      <tr>
        <td class="contentStyle">主导完成合同签订</td>
        <td class="contentStyle">30</td>
        <td class="incomeNumberStyle">30000</td>
        <td class="contentStyle">60</td>
        <td class="incomeNumberStyle">60000</td>
      </tr>
      <tr>
        <td class="partnerTitle">备注</td>
        <td colspan="6" class="contentStyle" style="text-align: left;padding-left: 78px;">二级创客：一级创客推荐新创客，且合计运营车位数500以上</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Cktable',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  background-color: rgba(255,255,255,1);
  padding-bottom: 56px;
}
.tableBox{
  width: 1200px;
  margin: 0 auto;
  border-collapse: collapse;
}
.tableBox td{
  border:1px solid rgba(204, 204, 204, 1);
  padding: 15px;
}
.titleLine td{
  border:1px solid rgba(255, 255, 255, 1);
  background-color: RGBA(12, 137, 24, 1);
  font-size:18px;
  font-weight:bold;
  color:rgba(255,255,255,1);
}
.partner{
  width: 190px;
}
.partnerContent{
  width: 300px;
}
.incomeTitle{
  width: 710px;
}
.partnerTitle{
   font-size: 16px;
   color:rgba(35,24,21,1);
}
.contentStyle{
  font-size: 14px;
  color:rgba(35,24,21,1);
}
.incomeNumberStyle{
  font-size:14px;
  font-weight:bold;
  color:rgba(255,182,30,1);
}
</style>



// WEBPACK FOOTER //
// src/components/ck/cktable.vue